import * as types from "../types";

const state = {
  orderListStep: false
};

const getters = {
  [types.orderListStep.getters.GET_ORDER_LIST_STEP]: state => {
    return state.orderListStep;
  }
};

const mutations = {
  [types.orderListStep.mutations.MUTATE_ORDER_LIST_STEP]: (state, payload) => {
    state.orderListStep = payload;
  }
};

const actions = {
  [types.orderListStep.actions.SET_ORDER_LIST_STEP]: ({ commit }, payload) => {
    commit(types.orderListStep.mutations.MUTATE_ORDER_LIST_STEP, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
